import React, { useState } from 'react';
import { Paper, Typography, Button, Box, IconButton } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import Draggable from 'react-draggable';
import { useTranslation } from 'react-i18next';

export default function OngoingEventsOverlay(props) {
    var ongoingEvents = props.ongoingEvents;
    var selectedFlood = props.selectedFlood;
    var updateSelectedFlood = props.updateSelectedFlood;
    var updateSelectedCountry = props.updateSelectedCountry;
    var countryData = props.countryData;

    var { t } = useTranslation();

    var [isVisible, setIsVisible] = useState(true);

    var countryKeys = Object.keys(ongoingEvents);

    // Calculate total events to handle pluralization
    var totalEvents = 0;
    countryKeys.forEach(function(code) {
        totalEvents += Object.keys(ongoingEvents[code]).length;
    });

    if (totalEvents === 0 || !isVisible) {
        return null;
    }

    return (
        <Draggable bounds="parent" handle=".drag-handle">
            <Box className={'ongoing-events'} sx={{
                position: 'absolute',
                top: 20,
                right: 20,
                zIndex: 1000,
                width: 'fit-content',
                maxWidth: 300,
                cursor: 'default'
            }}>
                <Paper
                    elevation={3}
                    sx={{
                        p: 1.5,
                        backgroundColor: 'rgba(255, 255, 255, 0.95)',
                        position: 'relative'
                    }}
                >
                    <Box
                        className="drag-handle"
                        sx={{
                            display: 'flex',
                            justifyContent: 'space-between',
                            alignItems: 'center',
                            cursor: 'move',
                            mb: 1,
                            borderBottom: '1px solid #eee',
                            pb: 0.5,
                            gap: 2
                        }}
                    >
                        <Typography
                            variant="h6"
                            component="div"
                            sx={{
                                fontSize: '0.9rem',
                                fontWeight: 'bold',
                                whiteSpace: 'nowrap'
                            }}
                        >
                            <span className={'active-cyclone'}>LIVE</span>
                            {/* Dynamic Title Pluralization */}
                            {totalEvents > 1 ? " Ongoing Floods" : " Ongoing Flood"}
                        </Typography>
                        <IconButton
                            size="small"
                            onClick={function() { setIsVisible(false); }}
                        >
                            <CloseIcon fontSize="small" />
                        </IconButton>
                    </Box>

                    {countryKeys.map(function(countryCode) {
                        var events = ongoingEvents[countryCode];
                        var sortedEventIds = Object.keys(events).sort().reverse();

                        return (
                            <Box key={countryCode} sx={{ mb: 1.5, textAlign: 'center' }}>
                                <Typography variant="subtitle2" sx={{ fontWeight: 'bold', color: '#666' }}>
                                    {t(`constants.countries.${countryCode}`)}
                                </Typography>

                                <Box sx={{
                                    display: 'flex',
                                    flexDirection: 'column',
                                    alignItems: 'center', // Centered buttons
                                    gap: 0.75,
                                    mt: 0.5,
                                    width: '100%'
                                }}>
                                    {sortedEventIds.map(function(evtId) {
                                        var eventData = events[evtId];
                                        var year = eventData.ongoing_event_year;
                                        var eventPath = null;

                                        if (countryData[countryCode] && countryData[countryCode]['year_by_year']) {
                                            var yearData = countryData[countryCode]['year_by_year'][year];
                                            if (yearData && yearData[evtId]) {
                                                eventPath = yearData[evtId].path;
                                            }
                                        }

                                        return (
                                            <Button
                                                key={evtId}
                                                variant={selectedFlood === eventPath ? "contained" : "outlined"}
                                                size="small"
                                                color={selectedFlood === eventPath ? "primary" : "secondary"}
                                                onClick={function() {
                                                    if (eventPath) {
                                                        updateSelectedCountry(countryCode);
                                                        updateSelectedFlood(eventPath);
                                                    }
                                                }}
                                                sx={{
                                                    fontSize: '0.7rem',
                                                    py: 0,
                                                    width: 'auto',
                                                    minWidth: '120px', // Uniform button width
                                                    maxWidth: '180px'
                                                }}
                                            >
                                                {evtId}
                                            </Button>
                                        );
                                    })}
                                </Box>
                            </Box>
                        );
                    })}
                </Paper>
            </Box>
        </Draggable>
    );
}
